import api from "../api.js";

const state = {
    selectedTenant: null,
    usersData: [],
    activeUsersCount: null,
    totalUsersCount: null
};

const mutations = {
    update(state, changes) {
        Object.assign(state, changes);
    },
    setUsageSummary(state, setUsageSummary) {
        state.usersData = setUsageSummary.data
        state.activeUsersCount = setUsageSummary?.info?.userCount
        state.totalUsersCount = setUsageSummary?.info?.totalUsers
    }
};

const getters = {
    allTenantsList(state, getters, rootState, rootGetters) {
        return rootGetters["admin/allTenantsList/getAll"]
    },

    selectedTenant(state, getters, rootState, rootGetters) {
        let adminState = rootState["admin"];
        return adminState.selectedTenant;
    },

    hideSidebar(state, getters, rootState, rootGetters) {
        let adminState = rootState["admin"];
        return adminState.hideSidebar;
    },
};

const root = { root: true };

const actions = {

    async loadAllTenants(context) {

        let data = await api.getAllTenants();
        if (data) {

            context.commit('admin/setSelectedTenant', data[0].id, root)

            context.commit("admin/allTenantsList/load", data, root);
        }
    },

    async loadUsageSummary(context, data) {

        let dataSet;
        if (data && data.excelClicked) {
            dataSet = await api.getAllUsageSummary(data, { responseType: 'blob' });
        } else {
            dataSet = await api.getAllUsageSummary(data);
        }
        if (dataSet) {
            if (dataSet && !dataSet.info) {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([dataSet])
                );
                link.setAttribute('download', 'Usage_Summary_Report.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                context.commit('setUsageSummary', dataSet)
            }
        }
    },

    setSelectedTenant(context, data) {
        context.commit('admin/setSelectedTenant', data, root)
    },

    hideSidebar(context, data) {
        context.commit('admin/hideSidebar', data, root)
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}